import * as React from 'react';
import { Checkbox as CheckboxCore, ICheckboxProps as ICheckboxPropsCore } from '../core/checkbox';

import styles from './checkbox.module.scss';

export interface ICheckboxProps extends ICheckboxPropsCore {}

const Checkbox = (props: ICheckboxProps): React.JSX.Element => {
	return <CheckboxCore {...props} propStyles={styles} />;
};

export { Checkbox };
